import { render, staticRenderFns } from "./PatientInput.vue?vue&type=template&id=4e855b03&scoped=true&"
import script from "./PatientInput.vue?vue&type=script&lang=js&"
export * from "./PatientInput.vue?vue&type=script&lang=js&"
import style0 from "./PatientInput.vue?vue&type=style&index=0&id=4e855b03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e855b03",
  null
  
)

export default component.exports